/* Natali Õnnis — Atelier · theme.js */
(function () {
  'use strict';

  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ===== Toast ===== */
  let toastTimer;
  function toast(msg) {
    const el = document.getElementById('ThemeToast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('show'), 2400);
  }
  window.themeToast = toast;

  /* ===== Cart drawer ===== */
  const cartScrim = document.getElementById('CartScrim');
  const cartDrawer = document.getElementById('CartDrawer');

  function openCart()  { if (!cartScrim) return; cartScrim.classList.add('open'); cartDrawer.classList.add('open'); document.body.style.overflow = 'hidden'; cartDrawer.setAttribute('aria-hidden', 'false'); }
  function closeCart() { if (!cartScrim) return; cartScrim.classList.remove('open'); cartDrawer.classList.remove('open'); document.body.style.overflow = ''; cartDrawer.setAttribute('aria-hidden', 'true'); }
  window.openCartDrawer = openCart;
  window.closeCartDrawer = closeCart;

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-close-cart]')) { e.preventDefault(); closeCart(); }
  });
  if (cartScrim) cartScrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCart();
      closeFilters();
      closeMobileNav();
      closeNavMega({ focusTrigger: true });
      // closeSortDropdown is scoped inside initAjaxFilters; close via DOM directly
      document.querySelectorAll('[data-sort-wrap].open').forEach(function(wrap) {
        wrap.classList.remove('open');
        const btn = wrap.querySelector('[data-sort-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
  });

  function formatMoney(cents) {
    try {
      const cur = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return '€' + (cents / 100).toFixed(2); }
  }

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return r.json();
  }

  // Parcely draws its delivery-point picker in its app block, which templates/cart.json
  // can only place above or below this whole section — and the app offers no setting to
  // move it. So move the rendered block ourselves, up into the slot between the line
  // items and the summary. Moving the node rather than mounting a second copy into an
  // #parcelyWidget target is what keeps it to one picker, with its listeners and state
  // intact. Runs before the app has necessarily filled the block in; that is fine, since
  // whatever it renders later lands in the block wherever the block now sits.
  function placeDeliveryWidget() {
    const slot = document.querySelector('[data-delivery-slot]');
    if (!slot || slot.childElementCount) return;
    const block = $$('#MainContent [id^="shopify-block-"]').find(el => !slot.contains(el));
    if (block) slot.appendChild(block);
  }

  // Parcely puts the same stock glyph — a courier carrying a parcel — beside every
  // method it has no carrier logo for, studio pickup included, where "someone is bringing
  // this to you" is exactly the wrong promise. The app has no per-method artwork setting
  // and draws the list client-side, so the swap happens from here: tag each row's logo
  // box, and base.css paints the theme's own artwork over whatever the app put there.
  // Text is the only thing in the widget's output that identifies a method, hence
  // matching on it; the needles are section settings so the methods can be retitled
  // without touching code. Both class spellings are covered, as elsewhere in the Parcely
  // overrides.
  const METHOD_ROWS = '.shipping_method, .shipping-method, .parcely_app_shipping_method';

  // Is this the row the shopper has settled on? Same pair of markings the .selected rules
  // in base.css cover, because the widget uses whichever suits its generation: a class on
  // the row, and a checked input inside it.
  function isChosenRow(row) {
    return (row.getAttribute('class') || '').toLowerCase().includes('selected')
      || !!row.querySelector('input:checked');
  }

  // Which kind of method is this row? One reading, shared by the icon swap and the
  // checkout caveats, so the two cannot drift apart — they key off the same pair of
  // section settings and would otherwise need the matching rules kept in step by hand.
  // Text is all the widget's output gives us to go on, hence matching on it.
  function classifyRow(row, pickupNeedle, parcelNeedle) {
    const label = row.textContent.toLowerCase();
    const isPickup = !!pickupNeedle && label.includes(pickupNeedle);
    // No parcel needle means "every method that is not the pickup": while studio pickup
    // is the only other thing on offer, naming the shipped one would be a second string
    // to keep in step with the app for no gain. It only holds once a pickup is named,
    // so clearing both settings still leaves every row unclassified.
    const isParcel = !isPickup && (parcelNeedle ? label.includes(parcelNeedle) : !!pickupNeedle);
    return { isPickup, isParcel };
  }

  // The two match settings, read off the slot where main-cart.liquid put them.
  function methodNeedles(slot) {
    return {
      pickupNeedle: (slot.dataset.pickupMatch || '').trim().toLowerCase(),
      parcelNeedle: (slot.dataset.parcelMatch || '').trim().toLowerCase()
    };
  }

  // Parcely's redirect does not reliably carry the chosen method through to Shopify's
  // checkout, so each method gets a line saying what to look for once it is over there.
  // Shown only once that method is the one on the table: a caveat shown to everyone is a
  // caveat nobody reads, and the two say opposite things.
  function refreshDeliveryNotes() {
    const pickupNote = $('[data-pickup-note]');
    const parcelNote = $('[data-parcel-note]');
    if (!pickupNote && !parcelNote) return;
    const slot = $('[data-delivery-slot]');
    let pickup = false, parcel = false;
    if (slot) {
      const { pickupNeedle, parcelNeedle } = methodNeedles(slot);
      $$(METHOD_ROWS, slot).forEach(row => {
        if (!isChosenRow(row)) return;
        const kind = classifyRow(row, pickupNeedle, parcelNeedle);
        pickup = pickup || kind.isPickup;
        parcel = parcel || kind.isParcel;
      });
    }
    if (pickupNote) pickupNote.hidden = !pickup;
    if (parcelNote) parcelNote.hidden = !parcel;
  }

  function markMethodIcons() {
    const slot = document.querySelector('[data-delivery-slot]');
    if (!slot) return;
    const { pickupNeedle, parcelNeedle } = methodNeedles(slot);
    if (!pickupNeedle && !parcelNeedle) return;
    slot.querySelectorAll(METHOD_ROWS).forEach(row => {
      const icon = row.querySelector('.shipping_icon');
      if (!icon) return;
      const { isPickup, isParcel } = classifyRow(row, pickupNeedle, parcelNeedle);
      // The parcel is a placeholder for a method whose destination is still unknown. Once
      // a point is picked the app draws that location's own artwork here, which says more
      // than our generic box does — so the class comes back off and the app's image
      // stands. The pin does not do this: studio pickup is one fixed address, and there
      // is nothing more specific for the app to swap in.
      icon.classList.toggle('pickup-icon', isPickup);
      icon.classList.toggle('parcel-icon', isParcel && !isChosenRow(row));
    });
  }

  // The list is not there on load and is redrawn whenever a point is picked, so one pass
  // would not hold. Observing the slot survives both: it is the same node the cart-page
  // re-render carries over (see swapSectionHTML), so the observer outlives that too.
  //
  // Attributes are watched as well as children, because picking a point can mark the row
  // .selected without redrawing it, and that is the moment the parcel placeholder has to
  // give way. The filter is what keeps that from spinning: our own class toggles land on
  // .shipping_icon, so a batch containing nothing else is this function hearing itself.
  // The change listener covers the remaining case, a widget that tracks the choice on the
  // input's property rather than in its markup — deferred a frame so it reads the state
  // the app has settled on rather than the one it is leaving.
  function watchMethodIcons() {
    const slot = document.querySelector('[data-delivery-slot]');
    if (!slot) return;
    const sync = () => { markMethodIcons(); refreshCheckoutGate(); refreshDeliveryNotes(); };
    sync();
    new MutationObserver(records => {
      const echo = records.every(r => r.type === 'attributes'
        && r.target.classList && r.target.classList.contains('shipping_icon'));
      if (!echo) sync();
    }).observe(slot, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    slot.addEventListener('change', () => requestAnimationFrame(sync));
  }

  // --- Checkout gate ------------------------------------------------------------
  // Parcely saves the chosen delivery point into the cart asynchronously, so a checkout
  // click that lands before that write produces an order with nowhere to send it. Parcely
  // guards this with its "checkout button delay" app embed, which hides the button until
  // its widget mounts — that is why the button used to arrive a beat after the picker —
  // and the guard did not survive swapSectionHTML() either, which rebuilds the summary
  // from fresh server markup with the button back in its default state. So that embed is
  // off (Theme editor → App embeds) and the gate lives here instead: the button holds its
  // place from first paint, dimmed and labelled with what it is waiting for, and goes live
  // the moment a point is settled on. Nothing appears late, so nothing moves.
  //
  // Fail open throughout. This stands between the shopper and a checkout they are entitled
  // to reach, so every uncertainty — no picker on the page, a picker that never loaded,
  // markup these selectors no longer recognise — resolves to letting them through. The
  // first gating pass is inline in main-cart.liquid rather than here, so that with JS off
  // the gate never closes at all and the button stays an ordinary working form submit.
  const GATE_TIMEOUT_MS = 10000;
  let sawMethodRows = false;   // the picker has proven it works at least once
  let lastChoice = false;      // the last reading we could actually take
  let gateForcedOpen = false;  // the watchdog gave up; see startGateWatchdog

  function deliveryChosen() {
    if (gateForcedOpen) return true;
    const slot = $('[data-delivery-slot]');
    if (!slot) return true;
    const rows = $$(METHOD_ROWS, slot);
    if (rows.length) {
      sawMethodRows = true;
      lastChoice = rows.some(isChosenRow);
    }
    // Rows come and go: the app redraws the whole list when a point is picked. An empty
    // moment mid-redraw is not the shopper un-choosing, so hold the last reading rather
    // than shutting the button and reopening it a frame later.
    return sawMethodRows ? lastChoice : false;
  }

  function refreshCheckoutGate() {
    const btn = $('[data-checkout-gate]');
    if (!btn) return;
    const gated = !deliveryChosen();
    btn.classList.toggle('is-gated', gated);
    btn.setAttribute('aria-disabled', gated ? 'true' : 'false');
    // swapSectionHTML() only carries the slot over once the widget is in it, so after the
    // watchdog has given up a quantity change hands back a fresh, empty slot — which the
    // CSS would hold open again for a picker we already know is not coming. Re-mark it.
    if (gateForcedOpen) {
      const slot = $('[data-delivery-slot]');
      if (slot && !slot.childElementCount) slot.classList.add('is-absent');
    }
  }

  // A gate with no picker behind it guards nothing and only blocks the sale. If the
  // timeout passes with no method row ever seen — script blocked, app down, or its class
  // names moved again — open it for good. This is not a "slow to choose" timer: one row
  // appearing proves the widget works, and from then on the shopper may take as long as
  // they like.
  function startGateWatchdog() {
    if (!$('[data-checkout-gate]')) return;
    setTimeout(() => {
      if (sawMethodRows) return;
      gateForcedOpen = true;
      const slot = $('[data-delivery-slot]');
      // Only give back the space the CSS is holding if nothing was drawn at all. A widget
      // that rendered something we cannot read still needs its room.
      if (slot && !slot.childElementCount) slot.classList.add('is-absent');
      refreshCheckoutGate();
    }, GATE_TIMEOUT_MS);
  }

  // Delegated, because swapSectionHTML() replaces the button on every quantity change.
  // The click is deliberately still ours to receive — hence aria-disabled rather than the
  // disabled attribute — so that pressing it answers the question it raises instead of
  // doing nothing: go to the picker and draw the eye to it.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-checkout-gate][aria-disabled="true"]');
    if (!btn) return;
    e.preventDefault();
    const slot = $('[data-delivery-slot]');
    if (!slot) return;
    slot.scrollIntoView({ behavior: 'smooth', block: 'center' });
    slot.classList.remove('is-nudged');
    void slot.offsetWidth;  // reflow, so a second click flashes again rather than sitting still
    slot.classList.add('is-nudged');
  });

  // The button is not the only way the cart form can be submitted, and the gate has to
  // hold for the others too.
  document.addEventListener('submit', (e) => {
    if (e.target.querySelector && e.target.querySelector('[data-checkout-gate][aria-disabled="true"]')) {
      e.preventDefault();
    }
  });

  // Swap in freshly-rendered section markup, carrying over the two things a plain
  // innerHTML assignment would destroy: the relocated delivery widget (the server has
  // no idea we moved it, so it renders the slot empty) and any note the shopper has
  // typed but not submitted.
  function swapSectionHTML(target, fresh) {
    const liveSlot = target.querySelector('[data-delivery-slot]');
    const placed = liveSlot && liveSlot.childElementCount ? liveSlot : null;
    const note = target.querySelector('[name="note"]');
    const noteValue = note ? note.value : null;

    target.innerHTML = fresh.innerHTML;

    if (placed) {
      const slot = target.querySelector('[data-delivery-slot]');
      if (slot) slot.replaceWith(placed);
    }
    if (noteValue !== null) {
      const freshNote = target.querySelector('[name="note"]');
      if (freshNote) freshNote.value = noteValue;
    }
  }

  async function renderCartDrawer() {
    if (!cartDrawer) return;
    const r = await fetch('/?section_id=cart-drawer');
    if (!r.ok) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = await r.text();
    const fresh = tmp.querySelector('#CartDrawer');
    if (fresh) swapSectionHTML(cartDrawer, fresh);
  }

  // The cart page shares the drawer's line-item controls, so it has to re-render too —
  // otherwise quantities, line totals and the subtotal on screen drift away from the
  // real cart until the shopper reloads.
  async function renderCartPage() {
    const section = document.querySelector('[data-cart-section]');
    if (!section) return;
    const r = await fetch(section.dataset.cartUrl + '?section_id=' + section.dataset.cartSection);
    if (!r.ok) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = await r.text();
    const fresh = tmp.querySelector('[data-cart-section]');
    if (fresh) swapSectionHTML(section, fresh);
    placeDeliveryWidget();
    refreshCheckoutGate();
    refreshDeliveryNotes();
  }

  function renderCartViews() {
    return Promise.all([renderCartDrawer(), renderCartPage()]);
  }

  async function updateCartBadge() {
    const c = await fetchCart();
    $$('[data-cart-count]').forEach(el => {
      el.textContent = c.item_count;
      el.style.display = c.item_count > 0 ? 'inline-flex' : 'none';
    });
    return c;
  }

  // Re-sync the drawer + badge from the real cart, then reveal it if non-empty.
  // Called on success AND on partial/error adds: Shopify returns 422 when an add
  // is capped by availability, but the server cart still changed — so we must
  // refresh the UI regardless, or the drawer/badge stay stale until a page reload.
  async function syncCartUI() {
    await renderCartViews();
    const cart = await updateCartBadge();
    if (cart && cart.item_count > 0) openCart();
    return cart;
  }

  async function addToCart(form) {
    const formData = new FormData(form);
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await r.json();
      await syncCartUI();
      if (!r.ok) { toast(data.description || 'Could not add to bag'); return; }
      toast('Added to bag · ' + (data.product_title || ''));
    } catch (err) { toast('Error adding to bag'); }
  }

  // Intercept add-to-cart forms
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action$="/cart/add"], form[action*="/cart/add"]');
    if (!form) return;
    if (form.dataset.noajax === 'true') return;
    e.preventDefault();
    addToCart(form);
  });

  // Quick-add buttons (variant_id already on the button)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const id = btn.getAttribute('data-quick-add');
    if (!id) return;
    btn.disabled = true;
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      const data = await r.json();
      await syncCartUI();
      if (!r.ok) { toast(data.description || 'Unavailable'); return; }
      toast('Added to bag');
    } finally { btn.disabled = false; }
  });

  // Cart line quantity changes
  document.addEventListener('click', async (e) => {
    const stepBtn = e.target.closest('[data-cart-qty]');
    if (!stepBtn) return;
    e.preventDefault();
    const line = Number(stepBtn.getAttribute('data-line'));
    const delta = Number(stepBtn.getAttribute('data-cart-qty'));
    const row = stepBtn.closest('[data-cart-item]');
    const current = Number(row?.getAttribute('data-qty') || '1');
    const next = Math.max(0, current + delta);
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity: next })
    });
    await renderCartViews();
    await updateCartBadge();
  });

  document.addEventListener('click', async (e) => {
    const rem = e.target.closest('[data-cart-remove]');
    if (!rem) return;
    e.preventDefault();
    const line = Number(rem.getAttribute('data-cart-remove'));
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity: 0 })
    });
    await renderCartViews();
    await updateCartBadge();
  });

  /* ===== Accordion ===== */
  document.addEventListener('click', (e) => {
    const head = e.target.closest('.acc-head');
    if (!head) return;
    const item = head.closest('.acc-item');
    const open = item.classList.contains('open');
    item.parentElement.querySelectorAll('.acc-item.open').forEach(o => o.classList.remove('open'));
    if (!open) item.classList.add('open');
  });

  /* ===== Filter group collapse ===== */
  document.addEventListener('click', (e) => {
    const head = e.target.closest('.filter-head');
    if (!head) return;
    head.parentElement.classList.toggle('collapsed');
  });

  /* ===== Wishlist (localStorage) ===== */
  const WISH_KEY = 'no_wishlist_v1';
  function getWishlist() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; } }
  function setWishlist(arr) { localStorage.setItem(WISH_KEY, JSON.stringify(arr)); }
  function refreshWishlistUI() {
    const list = getWishlist();
    $$('[data-wishlist-toggle]').forEach(btn => {
      const id = btn.getAttribute('data-wishlist-toggle');
      btn.classList.toggle('active', list.includes(id));
    });
    $$('[data-wishlist-count]').forEach(el => {
      el.textContent = list.length;
      el.style.display = list.length > 0 ? 'inline-flex' : 'none';
    });
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const id = btn.getAttribute('data-wishlist-toggle');
    const list = getWishlist();
    const i = list.indexOf(id);
    if (i >= 0) { list.splice(i, 1); toast('Removed from wishlist'); }
    else { list.push(id); toast('Saved to wishlist'); }
    setWishlist(list);
    refreshWishlistUI();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list } }));
  });
  refreshWishlistUI();

  // Filter the wishlist page (which renders all products initially)
  function applyWishlistView() {
    const view = document.querySelector('[data-wishlist-view]');
    if (!view) return;
    const list = getWishlist();
    let shown = 0;
    // Scope to [data-wishlist-grid] so featured cards in the empty state aren't counted
    const scope = view.querySelector('[data-wishlist-grid]') || view;
    scope.querySelectorAll('[data-pid]').forEach(card => {
      const id = card.getAttribute('data-pid');
      const match = list.includes(id);
      card.style.display = match ? '' : 'none';
      if (match) shown++;
    });
    const empty = document.querySelector('[data-wishlist-empty]');
    if (empty) empty.style.display = shown === 0 ? '' : 'none';
  }
  document.addEventListener('wishlist:change', applyWishlistView);
  applyWishlistView();

  /* ===== Locale switcher (dropdown) ===== */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-locale-toggle]');
    const wrap = btn ? btn.closest('.locale') : null;
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      wrap.classList.toggle('open');
      const menu = wrap.querySelector('.locale-menu');
      if (menu) menu.style.display = wrap.classList.contains('open') ? 'block' : 'none';
      return;
    }
    // close on outside click
    $$('.locale.open').forEach(w => {
      if (!w.contains(e.target)) {
        w.classList.remove('open');
        const m = w.querySelector('.locale-menu');
        if (m) m.style.display = 'none';
      }
    });
  });

  /* ===== Mobile nav ===== */
  const mobNav = document.getElementById('MobileNav');
  const mobScrim = document.getElementById('MobileNavScrim');

  function openMobileNav() {
    if (!mobNav) return;
    mobNav.classList.add('open');
    mobNav.setAttribute('aria-hidden', 'false');
    if (mobScrim) mobScrim.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobNav || !mobNav.classList.contains('open')) return;
    mobNav.classList.remove('open');
    mobNav.setAttribute('aria-hidden', 'true');
    if (mobScrim) mobScrim.classList.remove('open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-menu]')) { e.preventDefault(); openMobileNav(); }
    if (e.target.closest('[data-close-menu]')) { e.preventDefault(); closeMobileNav(); }
  });
  if (mobScrim) mobScrim.addEventListener('click', closeMobileNav);

  /* ===== Shop mega menu (desktop) =====
     Panel state lives on the DOM, not in captured references, so the theme
     editor can re-render the header section without stranding the handlers. */
  function openNavMega() {
    const panel = document.querySelector('[data-nav-mega]');
    if (!panel || panel.classList.contains('open')) return;
    panel.classList.add('open');
    const trigger = document.querySelector('[data-mega-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }
  function closeNavMega(opts) {
    const panel = document.querySelector('[data-nav-mega].open');
    if (!panel) return;
    panel.classList.remove('open');
    const trigger = document.querySelector('[data-mega-trigger]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      if (opts && opts.focusTrigger) trigger.focus();
    }
  }

  function initNavMega() {
    const panel = document.querySelector('[data-nav-mega]');
    const trigger = document.querySelector('[data-mega-trigger]');
    const wrap = trigger ? trigger.closest('[data-mega-wrap]') : null;
    if (!panel || !trigger || !wrap) return;

    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    let openTimer = null;
    let closeTimer = null;
    const clearTimers = () => { clearTimeout(openTimer); clearTimeout(closeTimer); };

    // Intent delays: a short one before opening so the panel does not flash
    // when the pointer merely crosses "Shop", a longer one before closing so
    // the diagonal move from the link down into the grid is forgiving.
    wrap.addEventListener('mouseenter', () => {
      if (!canHover.matches) return;
      clearTimers();
      openTimer = setTimeout(openNavMega, 120);
    });
    [wrap, panel].forEach((el) => {
      el.addEventListener('mouseleave', () => {
        if (!canHover.matches) return;
        clearTimers();
        closeTimer = setTimeout(closeNavMega, 200);
      });
    });
    panel.addEventListener('mouseenter', clearTimers);

    // Touch / coarse pointers get no hover: first tap opens, second follows
    // the link through to the unfiltered collection.
    trigger.addEventListener('click', (e) => {
      if (canHover.matches) return;
      if (!panel.classList.contains('open')) {
        e.preventDefault();
        clearTimers();
        openNavMega();
      }
    });

    // Keyboard: tabbing onto "Shop" reveals the panel, tabbing past it closes
    // (the dismissal half is document-level, registered once below).
    wrap.addEventListener('focusin', () => { clearTimers(); openNavMega(); });
    panel.addEventListener('focusin', clearTimers);
  }
  initNavMega();

  // Registered once — initNavMega() may re-run on section reload, and these
  // must not stack up. They re-query the DOM on every event.
  function dismissNavMegaFromOutside(e) {
    const panel = document.querySelector('[data-nav-mega].open');
    if (!panel) return;
    const trigger = document.querySelector('[data-mega-trigger]');
    const wrap = trigger ? trigger.closest('[data-mega-wrap]') : null;
    if (panel.contains(e.target) || (wrap && wrap.contains(e.target))) return;
    closeNavMega();
  }
  document.addEventListener('click', dismissNavMegaFromOutside);
  document.addEventListener('focusin', dismissNavMegaFromOutside);

  /* ===== Active category highlight (mega panel + drawer) =====
     The header renders on every template, so the active product type has to be
     read from the URL rather than from `collection.filters` (which is only
     filter-aware on a collection request). */
  function markActiveCategory() {
    const params = new URLSearchParams(location.search);
    const activeTypes = params.getAll('filter.p.product_type');
    let anyFilter = false;
    params.forEach((_value, key) => { if (key.indexOf('filter.') === 0) anyFilter = true; });
    const onShop = location.pathname.indexOf('/collections/all') !== -1;

    $$('[data-cat-type]').forEach((el) => {
      el.classList.toggle('is-active', activeTypes.indexOf(el.dataset.catType) !== -1);
    });
    $$('[data-cat-all]').forEach((el) => {
      el.classList.toggle('is-active', onShop && !anyFilter);
    });
  }
  markActiveCategory();
  window.addEventListener('popstate', markActiveCategory);

  /* ===== Filter drawer (mobile / tablet) ===== */
  const filterDrawer = document.getElementById('FilterDrawer');
  const filterScrim  = document.getElementById('FilterScrim');

  function openFilters() {
    if (!filterDrawer) return;
    filterDrawer.classList.add('open');
    if (filterScrim) { filterScrim.classList.add('open'); filterScrim.removeAttribute('aria-hidden'); }
    document.body.style.overflow = 'hidden';
  }
  function closeFilters() {
    if (!filterDrawer) return;
    filterDrawer.classList.remove('open');
    if (filterScrim) { filterScrim.classList.remove('open'); filterScrim.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-filter-toggle]')) { e.preventDefault(); openFilters(); }
    if (e.target.closest('[data-close-filters]')) { e.preventDefault(); closeFilters(); }
  });
  if (filterScrim) filterScrim.addEventListener('click', closeFilters);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeFilters(); });

  /* ===== Product gallery shared navigation ===== */
  function galleryNavigate(gallery, goNext) {
    const thumbs = [...gallery.querySelectorAll('.product-thumb:not([hidden])')];
    if (thumbs.length < 2) return;
    const activeThumb = thumbs.find(t => t.classList.contains('active')) || thumbs[0];
    const idx = thumbs.indexOf(activeThumb);
    const nextIdx = goNext ? (idx + 1) % thumbs.length : (idx - 1 + thumbs.length) % thumbs.length;
    const nextThumb = thumbs[nextIdx];
    gallery.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
    nextThumb.classList.add('active');
    const pos = nextThumb.getAttribute('data-position');
    gallery.querySelectorAll('.product-main-slide').forEach(slide => {
      slide.classList.toggle('active', slide.getAttribute('data-position') === pos);
    });
  }

  /* ===== Product gallery thumbs ===== */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('.product-gallery');
    if (!gallery) return;
    gallery.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    const pos = thumb.getAttribute('data-position');
    gallery.querySelectorAll('.product-main-slide').forEach(slide => {
      slide.classList.toggle('active', slide.getAttribute('data-position') === pos);
    });
  });

  /* ===== Product gallery click-to-navigate (left/right half) ===== */
  document.addEventListener('click', (e) => {
    const main = e.target.closest('.product-main');
    if (!main) return;
    const gallery = main.closest('.product-gallery');
    if (!gallery) return;
    const rect = main.getBoundingClientRect();
    galleryNavigate(gallery, e.clientX >= rect.left + rect.width / 2);
  });

  /* ===== Product gallery arrow key navigation ===== */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (e.target.closest('input, textarea, select')) return;
    const gallery = document.querySelector('.product-gallery');
    if (!gallery) return;
    galleryNavigate(gallery, e.key === 'ArrowRight');
  });

  /* ===== Product page: size / color / qty / variant selection ===== */
  function setupProductPage() {
    const wrap = document.querySelector('[data-product-form-wrap]');
    if (!wrap) return;
    const form = wrap.querySelector('form');
    if (!form) return;
    const variants = JSON.parse(wrap.getAttribute('data-variants') || '[]');
    const optionNames = JSON.parse(wrap.getAttribute('data-option-names') || '[]');
    const variantIdInput = form.querySelector('input[name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    const submitBtn = form.querySelector('[data-add-btn]');
    const qtyInput = form.querySelector('input[name="quantity"]');
    const mtoProp = form.querySelector('[data-mto-prop]');

    // Build color → first image position map from variant featured_image data
    const colorOptionIdx = optionNames.findIndex(n => /color|colour|värv|цвет/i.test(n));
    const sizeOptionIdx  = optionNames.findIndex(n => /size|suurus/i.test(n));
    const colorFirstPos = {};
    if (colorOptionIdx >= 0) {
      variants.forEach(v => {
        const color = v.options[colorOptionIdx];
        if (color && v.featured_image && !(color in colorFirstPos)) {
          colorFirstPos[color] = v.featured_image.position;
        }
      });
    }

    function getColorRange(color) {
      const start = colorFirstPos[color];
      if (!start) return null;
      const sorted = Object.values(colorFirstPos).sort((a, b) => a - b);
      const i = sorted.indexOf(start);
      const end = i < sorted.length - 1 ? sorted[i + 1] - 1 : Infinity;
      return [start, end];
    }

    function showSlide(pos) {
      const gallery = document.querySelector('.product-gallery');
      if (!gallery) return;
      const posStr = String(pos);
      gallery.querySelectorAll('.product-main-slide').forEach(s => {
        s.classList.toggle('active', s.getAttribute('data-position') === posStr);
      });
    }

    function updateGalleryForColor(colorValue) {
      const gallery = document.querySelector('.product-gallery');
      if (!gallery) return;
      const range = colorValue ? getColorRange(colorValue) : null;
      const thumbs = [...gallery.querySelectorAll('.product-thumb')];
      let firstThumb = null;
      thumbs.forEach(thumb => {
        const pos = parseInt(thumb.getAttribute('data-position'), 10);
        const visible = !range || (pos >= range[0] && pos <= range[1]);
        thumb.hidden = !visible;
        if (visible && !firstThumb) firstThumb = thumb;
      });
      if (firstThumb) {
        gallery.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
        firstThumb.classList.add('active');
        showSlide(firstThumb.getAttribute('data-position'));
      }
    }

    // Update size cells to reflect availability for the currently selected color
    function updateSizeCellAvailability() {
      if (sizeOptionIdx < 0) return;
      const sizeName = optionNames[sizeOptionIdx];
      const selectedColorEl = colorOptionIdx >= 0
        ? form.querySelector(`[data-option-name="${optionNames[colorOptionIdx]}"].selected`)
        : null;
      const selectedColor = selectedColorEl ? selectedColorEl.getAttribute('data-value') : null;

      form.querySelectorAll(`[data-option-name="${sizeName}"]`).forEach(function(cell) {
        const sizeVal = cell.getAttribute('data-value');
        const available = variants.some(function(v) {
          if (!v.available) return false;
          const colorMatch = colorOptionIdx < 0 || !selectedColor || v.options[colorOptionIdx] === selectedColor;
          return colorMatch && v.options[sizeOptionIdx] === sizeVal;
        });
        cell.classList.toggle('sold-out-cell', !available);
      });
    }

    function currentOptions() {
      const out = [];
      optionNames.forEach(name => {
        const sel = form.querySelector(`[data-option-name="${name}"].selected`);
        if (sel) out.push(sel.getAttribute('data-value'));
      });
      return out;
    }
    function matchVariant() {
      const opts = currentOptions();
      return variants.find(v => v.options.every((o, i) => o === opts[i]));
    }
    function refresh() {
      const v = matchVariant();
      if (!v) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Unavailable';
        updateSizeCellAvailability();
        return;
      }
      variantIdInput.value = v.id;
      submitBtn.disabled = !v.available;
      // Made-to-order: flag when the selected variant is a "Tailored" size.
      const isTailored = v.options.some(o => String(o).toLowerCase() === 'tailored');
      if (mtoProp) mtoProp.disabled = !isTailored;   // disabled => not submitted to cart
      const qty = Number(qtyInput?.value || 1);
      const total = (v.price * qty);
      if (v.available) {
        submitBtn.dataset.basePrice = v.price;
        submitBtn.innerHTML = 'Add to bag — ' + formatMoney(total);
      } else {
        submitBtn.textContent = 'Sold out';
      }
      if (priceEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceEl.innerHTML = `<s style="color:var(--ink-3);font-weight:400;margin-right:10px;">${formatMoney(v.compare_at_price)}</s>${formatMoney(v.price)}`;
        } else {
          priceEl.innerHTML = formatMoney(v.price);
        }
      }
      if (history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
      updateSizeCellAvailability();
    }

    // Apply initial gallery state for the pre-selected color
    if (colorOptionIdx >= 0) {
      const initialSwatch = form.querySelector(`[data-option-name="${optionNames[colorOptionIdx]}"].selected`);
      if (initialSwatch) updateGalleryForColor(initialSwatch.getAttribute('data-value'));
    }

    // Apply initial size availability
    updateSizeCellAvailability();

    form.addEventListener('click', (e) => {
      const opt = e.target.closest('[data-option-name]');
      if (!opt) return;
      e.preventDefault();
      const name = opt.getAttribute('data-option-name');
      form.querySelectorAll(`[data-option-name="${name}"]`).forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');
      const labelSpan = wrap.querySelector(`[data-current-option="${name}"]`);
      if (labelSpan) labelSpan.textContent = opt.getAttribute('data-value');
      if (colorOptionIdx >= 0 && name === optionNames[colorOptionIdx]) {
        updateGalleryForColor(opt.getAttribute('data-value'));
      }
      refresh();
    });
    form.addEventListener('click', (e) => {
      const step = e.target.closest('[data-qty-step]');
      if (!step || !qtyInput) return;
      e.preventDefault();
      const d = Number(step.getAttribute('data-qty-step'));
      qtyInput.value = Math.max(1, Number(qtyInput.value || 1) + d);
      const display = form.querySelector('[data-qty-display]');
      if (display) display.textContent = qtyInput.value;
      refresh();
    });
    refresh();
  }
  setupProductPage();

  /* ===== Mobile sticky add-to-bag bar ===== */
  function initMobAddBar() {
    const bar = document.getElementById('mob-add-bar');
    if (!bar) return;
    const wrap = document.querySelector('[data-product-form-wrap]');
    if (!wrap) return;
    const mainForm = wrap.querySelector('form');
    if (!mainForm) return;
    const mainAddBtn = mainForm.querySelector('[data-add-btn]');
    const mainPriceEl = document.querySelector('[data-product-price]');
    const mainCta = mainForm.querySelector('.product-cta');
    const barAddBtn = bar.querySelector('[data-mob-add-btn]');
    const barPriceEl = bar.querySelector('[data-mob-price]');

    function syncPrice() {
      if (barPriceEl && mainPriceEl) barPriceEl.innerHTML = mainPriceEl.innerHTML;
    }
    function syncBtn() {
      if (!barAddBtn || !mainAddBtn) return;
      barAddBtn.disabled = mainAddBtn.disabled;
      barAddBtn.textContent = mainAddBtn.textContent;
    }
    function syncOptions() {
      bar.querySelectorAll('[data-mob-option]').forEach(function(el) {
        var name = el.getAttribute('data-mob-option');
        var val  = el.getAttribute('data-value');
        var mainEl = mainForm.querySelector(
          '[data-option-name="' + name + '"][data-value="' + val + '"]'
        );
        if (!mainEl) return;
        el.classList.toggle('selected', mainEl.classList.contains('selected'));
        if (el.tagName === 'BUTTON') {
          el.classList.toggle('sold-out-cell', mainEl.classList.contains('sold-out-cell'));
        }
      });
    }

    syncPrice();
    syncBtn();
    syncOptions();

    var formObserver = new MutationObserver(syncOptions);
    formObserver.observe(mainForm, { subtree: true, attributes: true, attributeFilter: ['class'] });

    var uiObserver = new MutationObserver(function() { syncPrice(); syncBtn(); });
    if (mainPriceEl) uiObserver.observe(mainPriceEl, { subtree: true, childList: true, characterData: true });
    if (mainAddBtn)  uiObserver.observe(mainAddBtn,  { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });

    bar.addEventListener('click', function(e) {
      var opt = e.target.closest('[data-mob-option]');
      if (opt) {
        var name = opt.getAttribute('data-mob-option');
        var val  = opt.getAttribute('data-value');
        var mainOpt = mainForm.querySelector(
          '[data-option-name="' + name + '"][data-value="' + val + '"]'
        );
        if (mainOpt) mainOpt.click();
      }
      if (e.target.closest('[data-mob-add-btn]') && mainAddBtn) {
        mainAddBtn.click();
      }
    });

    function setVisible(v) {
      bar.classList.toggle('visible', v);
      bar.setAttribute('aria-hidden', String(!v));
    }

    if (window.IntersectionObserver && mainCta) {
      var io = new IntersectionObserver(function(entries) {
        // Show bar only while CTA is entirely below the viewport (not yet scrolled to)
        setVisible(!entries[0].isIntersecting && entries[0].boundingClientRect.top > 0);
      }, { threshold: 0.1 });
      io.observe(mainCta);
    }
  }
  initMobAddBar();

  /* ===== Color Swatch Palette ===== */
  function applySwatchColors() {
    const metaColors = window.__COLOR_SWATCHES__ || {};
    document.querySelectorAll('[data-color]').forEach(el => {
      const name = el.dataset.color;
      el.style.backgroundColor = metaColors[name] || name;
    });
  }

  applySwatchColors();

  /* Reload chrome on Shopify section reloads (theme editor) */
  document.addEventListener('shopify:section:load', () => {
    refreshWishlistUI();
    setupProductPage();
    initMobAddBar();
    applyWishlistView();
    applySwatchColors();
    initNavMega();
    markActiveCategory();
  });

  /* ===== AJAX Filters (Section Rendering API) ===== */
  (function initAjaxFilters() {
    if (!document.getElementById('FacetFilterForm')) return;

    let abortCtrl = null;

    function updateSliderUI(wrap) {
      const minInput = wrap.querySelector('.price-range-min');
      const maxInput = wrap.querySelector('.price-range-max');
      const fill = wrap.querySelector('.price-slider-fill');
      const minLabel = wrap.querySelector('[data-price-val="min"]');
      const maxLabel = wrap.querySelector('[data-price-val="max"]');
      const absMin = parseFloat(minInput.min);
      const absMax = parseFloat(minInput.max);
      const minVal = parseFloat(minInput.value);
      const maxVal = parseFloat(maxInput.value);
      const minPct = ((minVal - absMin) / (absMax - absMin)) * 100;
      const maxPct = ((maxVal - absMin) / (absMax - absMin)) * 100;
      if (fill) { fill.style.left = minPct + '%'; fill.style.width = (maxPct - minPct) + '%'; }
      if (minLabel) { minLabel.value = minVal; minLabel.style.width = (String(Math.round(minVal)).length + 1) + 'ch'; }
      if (maxLabel) { maxLabel.value = maxVal; maxLabel.style.width = (String(Math.round(maxVal)).length + 1) + 'ch'; }
      // Bring min thumb to front when both handles meet at the max end
      minInput.style.zIndex = minVal >= absMax ? '5' : '';
    }

    function updateActiveFilterCount() {
      const checkedCount = document.querySelectorAll('#FacetFilterForm input[type="checkbox"]:checked').length;
      const priceMin = document.querySelector('#FacetFilterForm [data-price-hidden="min"]');
      const priceMax = document.querySelector('#FacetFilterForm [data-price-hidden="max"]');
      const priceActive = ((priceMin && priceMin.value !== '') || (priceMax && priceMax.value !== '')) ? 1 : 0;
      const total = checkedCount + priceActive;
      document.querySelectorAll('[data-filter-count]').forEach(function(badge) {
        badge.textContent = total;
        badge.style.display = total > 0 ? 'inline-flex' : 'none';
      });
    }

    function syncTlrButton() {
      document.querySelectorAll('[data-tlr-filter]').forEach(function(btn) {
        const val = (btn.dataset.tlrFilter || '').toLowerCase();
        if (!val) return;
        const filterForm = document.getElementById('FacetFilterForm');
        const active = filterForm && Array.from(
          filterForm.querySelectorAll('.size-cell input[type="checkbox"]')
        ).some(function(cb) { return cb.checked && cb.value.toLowerCase() === val; });
        btn.classList.toggle('tlr__btn--active', !!active);
      });
    }

    function collapseFilterChips() {
      const bar = document.getElementById('ActiveFilters');
      if (!bar) return;
      const existingMore = bar.querySelector('[data-more-filters]');
      if (existingMore) existingMore.remove();
      const allChips = Array.from(bar.querySelectorAll('[data-filter-chip]'));
      const clearAll = bar.querySelector('[data-clear-filters]');
      allChips.forEach(function(c) { c.style.display = ''; });
      if (clearAll) clearAll.style.display = '';
      if (window.innerWidth > 720 || !allChips.length) return;

      function getRowTops() {
        const tops = [];
        Array.from(bar.children).forEach(function(c) {
          if (c.style.display === 'none') return;
          const top = c.offsetTop;
          if (tops.indexOf(top) === -1) tops.push(top);
        });
        return tops.sort(function(a, b) { return a - b; });
      }

      if (getRowTops().length <= 2) return;

      const moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'active-filter-chip active-filter-chip--more';
      moreBtn.setAttribute('data-more-filters', '');
      moreBtn.setAttribute('data-filter-toggle', '');
      moreBtn.textContent = '+1 more';
      if (clearAll) bar.insertBefore(moreBtn, clearAll); else bar.appendChild(moreBtn);

      let hiddenCount = 0;
      while (getRowTops().length > 2) {
        const visible = allChips.filter(function(c) { return c.style.display !== 'none'; });
        if (!visible.length) break;
        visible[visible.length - 1].style.display = 'none';
        hiddenCount++;
        moreBtn.textContent = '+' + hiddenCount + ' more';
      }

      if (!hiddenCount) moreBtn.remove();
    }

    function findCheckbox(name, value) {
      const inputs = document.querySelectorAll('#FacetFilterForm input[type="checkbox"][name="' + name + '"]');
      for (let i = 0; i < inputs.length; i++) {
        if (inputs[i].value === value) return inputs[i];
      }
      return null;
    }

    function updateFilterSidebar(newFiltersEl) {
      // Update filter-opt checkboxes: active state + count + disabled
      newFiltersEl.querySelectorAll('.filter-opt input[type="checkbox"]').forEach(function(newCb) {
        const curCb = findCheckbox(newCb.name, newCb.value);
        if (!curCb) return;
        curCb.checked = newCb.checked;
        const curOpt = curCb.closest('.filter-opt');
        const newOpt = newCb.closest('.filter-opt');
        if (!curOpt || !newOpt) return;
        curOpt.classList.toggle('selected', newCb.checked);
        curOpt.classList.toggle('filter-disabled', newOpt.classList.contains('filter-disabled') && !newCb.checked);
        const curQty = curOpt.querySelector('.qty');
        const newQty = newOpt.querySelector('.qty');
        if (curQty && newQty) curQty.textContent = newQty.textContent;
      });

      // Update color swatches
      newFiltersEl.querySelectorAll('.color-swatch input[type="checkbox"]').forEach(function(newCb) {
        const curCb = findCheckbox(newCb.name, newCb.value);
        if (!curCb) return;
        curCb.checked = newCb.checked;
        const curSwatch = curCb.closest('.color-swatch');
        const newSwatch = newCb.closest('.color-swatch');
        curSwatch.classList.toggle('selected', newCb.checked);
        curSwatch.classList.toggle('filter-disabled', newSwatch.classList.contains('filter-disabled') && !newCb.checked);
      });

      // Update size cells
      newFiltersEl.querySelectorAll('.size-cell input[type="checkbox"]').forEach(function(newCb) {
        const curCb = findCheckbox(newCb.name, newCb.value);
        if (!curCb) return;
        curCb.checked = newCb.checked;
        const curCell = curCb.closest('.size-cell');
        const newCell = newCb.closest('.size-cell');
        curCell.classList.toggle('selected', newCb.checked);
        curCell.classList.toggle('filter-disabled', newCell.classList.contains('filter-disabled') && !newCb.checked);
      });

      // Update price slider
      const newWrap = newFiltersEl.querySelector('.price-slider');
      const curWrap = document.querySelector('#FacetFilterForm .price-slider');
      if (newWrap && curWrap) {
        ['min', 'max'].forEach(function(side) {
          const newHidden = newWrap.querySelector('[data-price-hidden="' + side + '"]');
          const curHidden = curWrap.querySelector('[data-price-hidden="' + side + '"]');
          const newRange  = newWrap.querySelector('.price-range-' + side);
          const curRange  = curWrap.querySelector('.price-range-' + side);
          if (newHidden && curHidden) curHidden.value = newHidden.value;
          if (newRange  && curRange)  curRange.value  = newRange.value;
        });
        updateSliderUI(curWrap);
      }
    }

    function initFilterOrder() {
      const STORAGE_KEY = 'forder:' + location.pathname;
      const MAX_AGE = 7 * 24 * 60 * 60 * 1000; // 7 days

      function buildOrderMap(filtersEl) {
        const map = new Map(); // groupIdx -> [key, ...]
        filtersEl.querySelectorAll('.filter-group').forEach(function(group, idx) {
          const keys = [];
          group.querySelectorAll('.filter-opt input[type="checkbox"], .color-swatch input[type="checkbox"], .size-cell input[type="checkbox"]').forEach(function(cb) {
            keys.push(cb.name + '::' + cb.value);
          });
          if (keys.length) map.set(idx, keys);
        });
        return map;
      }

      function applyOrder(orderMap) {
        const groups = document.querySelectorAll('#FacetFilterForm .filter-group');
        orderMap.forEach(function(keys, idx) {
          const group = groups[idx];
          if (!group) return;
          const elemMap = new Map();
          // Default all items to a high order so unlisted values sink to the end
          group.querySelectorAll('.filter-opt, .color-swatch, .size-cell').forEach(function(el) {
            el.style.order = 9999;
            const cb = el.querySelector('input[type="checkbox"]');
            if (cb) elemMap.set(cb.name + '::' + cb.value, el);
          });
          keys.forEach(function(key, i) {
            const el = elemMap.get(key);
            if (el) el.style.order = i;
          });
        });
      }

      function saveOrder() {
        const filtersEl = document.querySelector('.filters');
        if (!filtersEl) return;
        const map = buildOrderMap(filtersEl);
        const serialised = {};
        map.forEach(function(keys, idx) { serialised[idx] = keys; });
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now(), order: serialised })); } catch(e) {}
      }

      function loadOrder() {
        try {
          const raw = localStorage.getItem(STORAGE_KEY);
          if (!raw) return null;
          const parsed = JSON.parse(raw);
          if (Date.now() - parsed.ts > MAX_AGE) { localStorage.removeItem(STORAGE_KEY); return null; }
          return parsed.order;
        } catch(e) { return null; }
      }

      function applyFromStored(stored) {
        const map = new Map();
        Object.keys(stored).forEach(function(k) { map.set(Number(k), stored[k]); });
        applyOrder(map);
      }

      const hasFilterParams = Array.from(new URLSearchParams(location.search).keys())
        .some(function(k) { return k.startsWith('filter.'); });

      if (!hasFilterParams) {
        // Unfiltered page — canonical order is known; save and return
        saveOrder();
        return;
      }

      const stored = loadOrder();
      if (stored) { applyFromStored(stored); return; }

      // First-ever visit direct to a filtered URL — fetch unfiltered section once
      fetch(location.pathname + '?sections=main-collection')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (!data['main-collection']) return;
          const doc = new DOMParser().parseFromString(data['main-collection'], 'text/html');
          const filtersEl = doc.querySelector('.filters');
          if (!filtersEl) return;
          const map = buildOrderMap(filtersEl);
          const serialised = {};
          map.forEach(function(keys, idx) { serialised[idx] = keys; });
          try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now(), order: serialised })); } catch(e) {}
          applyOrder(map);
        })
        .catch(function() {});
    }

    function initPriceSliders() {
      document.querySelectorAll('.price-slider').forEach(function(wrap) {
        if (wrap.dataset.sliderInit) return;
        wrap.dataset.sliderInit = '1';
        updateSliderUI(wrap);
      });
    }

    function getParams() {
      const filterForm = document.getElementById('FacetFilterForm');
      const sortHidden = document.querySelector('[data-sort-hidden]');
      const params = new URLSearchParams();

      if (filterForm) {
        new FormData(filterForm).forEach((value, key) => {
          if (value !== '') params.append(key, value);
        });
      }

      if (params.get('filter.v.price.gte') === '') params.delete('filter.v.price.gte');
      if (params.get('filter.v.price.lte') === '') params.delete('filter.v.price.lte');

      if (sortHidden && sortHidden.value) params.set('sort_by', sortHidden.value);

      return params;
    }

    function closeSortDropdown() {
      document.querySelectorAll('[data-sort-wrap].open').forEach(function(wrap) {
        wrap.classList.remove('open');
        const btn = wrap.querySelector('[data-sort-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    // Sort dropdown toggle
    document.addEventListener('click', function(e) {
      const toggle = e.target.closest('[data-sort-toggle]');
      if (toggle) {
        e.preventDefault();
        const wrap = toggle.closest('[data-sort-wrap]');
        const isOpen = wrap.classList.contains('open');
        closeSortDropdown();
        if (!isOpen) {
          wrap.classList.add('open');
          toggle.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      // Sort option selected
      const opt = e.target.closest('[data-sort-value]');
      if (opt) {
        e.preventDefault();
        const wrap = opt.closest('[data-sort-wrap]');
        if (!wrap) return;
        const value = opt.getAttribute('data-sort-value');
        const hidden = document.querySelector('[data-sort-hidden]');
        if (hidden) hidden.value = value;
        document.querySelectorAll('[data-sort-label]').forEach(function(el) { el.textContent = opt.textContent.trim(); });
        document.querySelectorAll('[data-sort-label-short]').forEach(function(el) { el.textContent = opt.getAttribute('data-sort-short') || opt.textContent.trim(); });
        wrap.querySelectorAll('[data-sort-value]').forEach(function(o) {
          const active = o.getAttribute('data-sort-value') === value;
          o.classList.toggle('active', active);
          o.setAttribute('aria-selected', String(active));
        });
        closeSortDropdown();
        updateCollection(getParams());
        return;
      }

      // Outside click — close
      if (!e.target.closest('[data-sort-wrap]')) closeSortDropdown();
    });

    async function updateCollection(params) {
      const resultsEl = document.getElementById('CollectionResults');
      if (!resultsEl) return;

      const pageURL = new URL(window.location.pathname, window.location.origin);
      params.forEach((value, key) => pageURL.searchParams.append(key, value));
      history.pushState({}, '', pageURL.toString());

      if (abortCtrl) abortCtrl.abort();
      abortCtrl = new AbortController();

      resultsEl.style.opacity = '0.5';
      resultsEl.style.transition = 'opacity 0.15s';
      resultsEl.style.pointerEvents = 'none';

      try {
        const resp = await fetch(pageURL.toString(), { signal: abortCtrl.signal });
        if (!resp.ok) throw new Error('Filter fetch failed');
        const html = await resp.text();

        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newResults = doc.getElementById('CollectionResults');
        if (newResults) resultsEl.innerHTML = newResults.innerHTML;

        const newFiltersEl = doc.querySelector('.filters');
        if (newFiltersEl) updateFilterSidebar(newFiltersEl);

        const newCount = doc.querySelector('.shop-toolbar-top .count');
        const curCount = document.querySelector('.shop-toolbar-top .count');
        if (newCount && curCount) curCount.textContent = newCount.textContent;

        applySwatchColors();
        updateActiveFilterCount();
        syncTlrButton();
        collapseFilterChips();
        markActiveCategory();

        const resultsBottom = resultsEl.getBoundingClientRect().bottom + window.scrollY;
        if (window.scrollY > resultsBottom) {
          const resultsTop = resultsEl.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: Math.max(0, resultsTop - 16), behavior: 'smooth' });
        }

      } catch (err) {
        if (err.name !== 'AbortError') console.warn('Filter update error:', err);
      } finally {
        resultsEl.style.opacity = '';
        resultsEl.style.pointerEvents = '';
      }
    }

    function onPopState() {
      const resultsEl = document.getElementById('CollectionResults');
      if (!resultsEl) return;

      fetch(window.location.href)
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newResults = doc.getElementById('CollectionResults');
          if (newResults) resultsEl.innerHTML = newResults.innerHTML;

          const newFilters = doc.querySelector('.filters');
          if (newFilters) updateFilterSidebar(newFilters);

          const newCount = doc.querySelector('.shop-toolbar-top .count');
          const curCount = document.querySelector('.shop-toolbar-top .count');
          if (newCount && curCount) curCount.textContent = newCount.textContent;

          applySwatchColors();
          updateActiveFilterCount();
          syncTlrButton();
          collapseFilterChips();
          markActiveCategory();
        })
        .catch(console.warn);
    }

    document.addEventListener('input', function(e) {
      if (!e.target.closest('#FacetFilterForm')) return;

      // Resize editable price label as user types
      if (e.target.classList.contains('price-val-input')) {
        const len = e.target.value.length || 1;
        e.target.style.width = (len + 1) + 'ch';
        return;
      }

      if (e.target.type !== 'range') return;
      const wrap = e.target.closest('.price-slider');
      if (!wrap) return;
      const minInput = wrap.querySelector('.price-range-min');
      const maxInput = wrap.querySelector('.price-range-max');
      if (e.target === minInput && parseFloat(minInput.value) > parseFloat(maxInput.value)) {
        minInput.value = maxInput.value;
      } else if (e.target === maxInput && parseFloat(maxInput.value) < parseFloat(minInput.value)) {
        maxInput.value = minInput.value;
      }
      const absMin = parseFloat(minInput.min);
      const absMax = parseFloat(maxInput.max);
      const minVal = parseFloat(minInput.value);
      const maxVal = parseFloat(maxInput.value);
      wrap.querySelector('[data-price-hidden="min"]').value = minVal > absMin ? minVal : '';
      wrap.querySelector('[data-price-hidden="max"]').value = maxVal < absMax ? maxVal : '';
      updateSliderUI(wrap);
    });

    // Active filter chip removal
    document.addEventListener('click', function(e) {
      const chip = e.target.closest('[data-filter-chip]');
      if (!chip) return;

      // Clear-price chip: reset price range and resubmit
      if (chip.hasAttribute('data-clear-price')) {
        e.preventDefault();
        document.querySelectorAll('#FacetFilterForm .price-slider').forEach(function(wrap) {
          const minInput = wrap.querySelector('.price-range-min');
          const maxInput = wrap.querySelector('.price-range-max');
          if (!minInput || !maxInput) return;
          minInput.value = minInput.min;
          maxInput.value = maxInput.max;
          wrap.querySelector('[data-price-hidden="min"]').value = '';
          wrap.querySelector('[data-price-hidden="max"]').value = '';
          updateSliderUI(wrap);
        });
        updateCollection(getParams());
        return;
      }

      // Clear-all chip: handled by existing data-clear-filters handler below
      if (chip.hasAttribute('data-clear-filters')) return;

      // Single filter chip: navigate to the removal URL
      e.preventDefault();
      const href = chip.getAttribute('href');
      if (!href) return;
      const url = new URL(href, window.location.origin);
      updateCollection(url.searchParams);
    });

    document.addEventListener('click', function(e) {
      const tlrBtn = e.target.closest('[data-tlr-filter]');
      if (tlrBtn) {
        e.preventDefault();
        const filterForm = document.getElementById('FacetFilterForm');
        if (!filterForm) return;
        const val = (tlrBtn.dataset.tlrFilter || '').toLowerCase();
        const allSizeCbs = filterForm.querySelectorAll('.size-cell input[type="checkbox"]');
        let targetCb = null;
        allSizeCbs.forEach(function(cb) {
          if (cb.value.toLowerCase() === val) targetCb = cb;
        });
        if (!targetCb) return;
        const willCheck = !targetCb.checked;
        allSizeCbs.forEach(function(cb) {
          cb.checked = false;
          const cell = cb.closest('.size-cell');
          if (cell) cell.classList.remove('selected');
        });
        if (willCheck) {
          targetCb.checked = true;
          const cell = targetCb.closest('.size-cell');
          if (cell) cell.classList.add('selected');
        }
        updateActiveFilterCount();
        syncTlrButton();
        collapseFilterChips();
        updateCollection(getParams());
        return;
      }
    });

    document.addEventListener('click', function(e) {
      const clearBtn = e.target.closest('[data-clear-filters]');
      if (!clearBtn) return;
      e.preventDefault();
      const filterForm = document.getElementById('FacetFilterForm');
      if (filterForm) {
        filterForm.querySelectorAll('input[type="checkbox"]').forEach(cb => { cb.checked = false; });
        filterForm.querySelectorAll('.filter-opt.selected, .color-swatch.selected, .size-cell.selected').forEach(el => { el.classList.remove('selected'); });
        filterForm.querySelectorAll('.price-slider').forEach(function(wrap) {
          const minInput = wrap.querySelector('.price-range-min');
          const maxInput = wrap.querySelector('.price-range-max');
          if (!minInput || !maxInput) return;
          minInput.value = minInput.min;
          maxInput.value = maxInput.max;
          wrap.querySelector('[data-price-hidden="min"]').value = '';
          wrap.querySelector('[data-price-hidden="max"]').value = '';
          updateSliderUI(wrap);
        });
      }
      updateCollection(new URLSearchParams());
      updateActiveFilterCount();
      syncTlrButton();
      collapseFilterChips();
    });

    document.addEventListener('change', function(e) {
      if (e.target.closest('#FacetFilterForm')) {
        if (e.target.type === 'checkbox') {
          const label = e.target.closest('.filter-opt, .color-swatch, .size-cell');
          if (label) label.classList.toggle('selected', e.target.checked);
        }
        if (e.target.classList.contains('price-val-input')) {
          const wrap = e.target.closest('.price-slider');
          if (wrap) {
            const minRng = wrap.querySelector('.price-range-min');
            const maxRng = wrap.querySelector('.price-range-max');
            const absMin = parseFloat(minRng.min);
            const absMax = parseFloat(maxRng.max);
            let val = parseInt(e.target.value, 10);
            if (isNaN(val)) val = e.target.dataset.priceVal === 'min' ? absMin : absMax;
            val = Math.max(absMin, Math.min(absMax, val));
            if (e.target.dataset.priceVal === 'min') {
              minRng.value = Math.min(val, parseFloat(maxRng.value));
            } else {
              maxRng.value = Math.max(val, parseFloat(minRng.value));
            }
            const minVal = parseFloat(minRng.value);
            const maxVal = parseFloat(maxRng.value);
            wrap.querySelector('[data-price-hidden="min"]').value = minVal > absMin ? minVal : '';
            wrap.querySelector('[data-price-hidden="max"]').value = maxVal < absMax ? maxVal : '';
            updateSliderUI(wrap);
            updateCollection(getParams());
          }
          return;
        }
        if (e.target.type !== 'number') updateCollection(getParams());
        return;
      }
    });

    document.addEventListener('submit', function(e) {
      if (e.target.id === 'FacetFilterForm') {
        e.preventDefault();
        updateCollection(getParams());
      }
    });

    window.addEventListener('popstate', onPopState);

    let _chipResizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(_chipResizeTimer);
      _chipResizeTimer = setTimeout(collapseFilterChips, 150);
    });

    applySwatchColors();
    initPriceSliders();
    initFilterOrder();
    updateActiveFilterCount();
    syncTlrButton();
    collapseFilterChips();
  })();

  /* ===== Mobile filter/sort bar — show only while product grid is in view ===== */
  (function initMobFilterBarVisibility() {
    const bar = document.querySelector('.mob-filter-bar');
    const results = document.getElementById('CollectionResults');
    if (!bar || !results) return;
    const observer = new IntersectionObserver(function(entries) {
      bar.classList.toggle('mob-filter-bar--hidden', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(results);
  })();

  /* ===== Size guide panel ===== */
  (function initSizeGuide() {
    const scrim = document.getElementById('sg-scrim');
    const panel = document.getElementById('sg-panel');
    if (!scrim || !panel) return;
    function open()  { scrim.classList.add('open'); panel.classList.add('open'); document.body.style.overflow = 'hidden'; panel.setAttribute('aria-hidden', 'false'); }
    function close() { scrim.classList.remove('open'); panel.classList.remove('open'); document.body.style.overflow = ''; panel.setAttribute('aria-hidden', 'true'); }
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-open-size-guide]'))  { e.preventDefault(); open(); }
      if (e.target.closest('[data-close-size-guide]')) { e.preventDefault(); close(); }
    });
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  })();

  /* ===== Product recommendations (Search & Discovery — section rendering API) ===== */
  (function initProductRecommendations() {
    const section = document.getElementById('product-recommendations');
    if (!section) return;
    const productId = section.dataset.productId;
    const recsUrl = section.dataset.recsUrl;
    const grid = document.getElementById('recommendations-grid');
    const base = `${recsUrl}?section_id=product-recommendations&product_id=${productId}&limit=6`;

    Promise.all([
      fetch(`${base}&intent=complementary`).then(r => r.text()).catch(() => ''),
      fetch(`${base}&intent=related`).then(r => r.text()).catch(() => '')
    ]).then(([complementaryHtml, relatedHtml]) => {
      const parser = new DOMParser();
      const seen = new Set();
      const cards = [];

      // Complementary first (manually curated), then related (algorithmic fallback)
      for (const html of [complementaryHtml, relatedHtml]) {
        if (!html) continue;
        parser.parseFromString(html, 'text/html')
          .querySelectorAll('[data-pid]')
          .forEach(card => {
            const pid = card.dataset.pid;
            if (!seen.has(pid)) { seen.add(pid); cards.push(card.cloneNode(true)); }
          });
      }

      if (cards.length === 0) return;
      cards.slice(0, 4).forEach(card => grid.appendChild(card));
      applySwatchColors();
      section.style.display = '';
    });
  })();

  /* ===== Announcement bar — ensure track fills screen & scrolls by exact copy width ===== */
  (function initAnnounceBar() {
    const track = document.querySelector('.announce-track');
    if (!track) return;
    const firstCopy = track.querySelector('.announce-copy');
    if (!firstCopy) return;

    const copyWidth = firstCopy.offsetWidth;
    if (!copyWidth) return;

    // Clone until the track is at least 3× the viewport width
    const needed = Math.ceil((window.innerWidth * 3) / copyWidth);
    let count = track.querySelectorAll('.announce-copy').length;
    while (count < needed) {
      const clone = firstCopy.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      count++;
    }

    // Drive the animation by exactly one copy width so the seam is always invisible
    track.style.setProperty('--scroll-amount', `-${copyWidth}px`);
  })();

  placeDeliveryWidget();
  watchMethodIcons();
  refreshCheckoutGate();
  refreshDeliveryNotes();
  startGateWatchdog();


})();
